import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fcc51c62"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-red-500 text-center py-2 bg-red-100 rounded mb-4"
}
const _hoisted_2 = { class: "file mb-4" }
const _hoisted_3 = {
  key: 0,
  class: "file-input"
}
const _hoisted_4 = {
  key: 0,
  class: "cursor-pointer inline-flex items-center rounded px-3 py-2 text-white font-semibold bg-primary",
  for: "file-input"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Upload template ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Upload template ...")
const _hoisted_7 = {
  key: 1,
  class: "text-lg"
}
const _hoisted_8 = { class: "text-primary flex items-center justify-between bg-gray-100 rounded px-2" }
const _hoisted_9 = { class: "flex items-center gap-x-2" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "pt-2 cursor-pointer" }
const _hoisted_12 = { class: "flex gap-x-2 items-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "w-20 font-semibold" }, [
  /*#__PURE__*/_createTextVNode(" Subject "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-600" }, "*")
], -1))
const _hoisted_14 = { class: "flex gap-x-2 items-center mt-3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold w-20" }, [
  /*#__PURE__*/_createTextVNode(" Sender "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-600" }, "*")
], -1))
const _hoisted_16 = {
  key: 1,
  class: "flex gap-x-2 items-center mt-3"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold w-20" }, [
  /*#__PURE__*/_createTextVNode(" Email "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-600" }, "*")
], -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Close")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Send email")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadFilled = _resolveComponent("UploadFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Link = _resolveComponent("Link")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    title: "Email",
    width: "630",
    top: "30vh"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.close()))
      }, {
        default: _withCtx(() => [
          _hoisted_18
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.sendEmail
      }, {
        default: _withCtx(() => [
          _hoisted_19
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      (_ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, " Please fill all required fields "))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.fileList.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("input", {
                type: "file",
                name: "file-input",
                id: "file-input",
                accept: ".html",
                ref: "file",
                class: "file-input__input",
                onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.uploadFile($event)))
              }, null, 544),
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("label", _hoisted_4, [
                    _createVNode(_component_el_icon, {
                      size: "18",
                      class: "mr-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_UploadFilled)
                      ]),
                      _: 1
                    }),
                    _hoisted_5
                  ]))
                : _createCommentVNode("", true),
              (_ctx.loading)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    text: "",
                    loading: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Link)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("a", {
                    href: _ctx.imageUrl(_ctx.fileList[0].path),
                    target: "_blank"
                  }, " Email template ", 8, _hoisted_10)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_el_icon, {
                    color: "#f87171",
                    onClick: _ctx.deleteTemplate
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Delete)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ]))
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(_component_el_input, {
          modelValue: _ctx.subject,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.subject) = $event)),
          class: "w-full",
          placeholder: "Enter subject"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode(_component_el_select, {
          modelValue: _ctx.platform,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.platform) = $event)),
          placeholder: "Select platform",
          class: "w-full"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: "LatteX",
              value: "latte"
            }),
            _createVNode(_component_el_option, {
              label: "Cybersilk",
              value: "cybersilk"
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      (_ctx.platform)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_el_select, {
              modelValue: _ctx.sender,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sender) = $event)),
              placeholder: "Select email",
              class: "w-full"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listEmail, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}